var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c("list-edition-toolbar", {
        attrs: { buttons: _vm.toolbarButtons },
        on: {
          edit: function($event) {
            _vm.editionDisabled = false
          },
          delete: function($event) {
            _vm.deleteDialog = true
          },
          save: _vm.save,
          cancel: _vm.cancel
        }
      }),
      _vm._v(" "),
      _vm.editedTask !== null
        ? _c(
            "v-layout",
            {
              staticClass: "task-form-container",
              attrs: { row: "", wrap: "" }
            },
            [
              _c("input-field", {
                attrs: {
                  label: _vm.$t("Title"),
                  "variable-name": "title",
                  "input-type": "text",
                  size: "small",
                  "field-disabled": _vm.editionDisabled,
                  required: ""
                },
                model: {
                  value: _vm.editedTask.title,
                  callback: function($$v) {
                    _vm.$set(_vm.editedTask, "title", $$v)
                  },
                  expression: "editedTask.title"
                }
              }),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    label: _vm.$tc("Assignee", 1),
                    value: _vm.editedTask.user_assignee_id,
                    "variable-name": "user_assignee_id",
                    "input-type": "other",
                    size: "small",
                    "field-disabled": _vm.editionDisabled
                  }
                },
                [
                  _c("treeselect", {
                    staticClass: "form-input-select",
                    attrs: {
                      options: _vm.userOptions,
                      "disable-branch-nodes": true,
                      "value-consists-of": "LEAF_PRIORITY",
                      disableFuzzyMatching: "",
                      loadOptions: _vm.loadAllUsers,
                      disabled: _vm.editionDisabled
                    },
                    model: {
                      value: _vm.editedTask.user_assignee_id,
                      callback: function($$v) {
                        _vm.$set(_vm.editedTask, "user_assignee_id", $$v)
                      },
                      expression: "editedTask.user_assignee_id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: "",
                  value: "",
                  "input-type": "space",
                  size: "small"
                }
              }),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$t("ScheduledFor"),
                  "variable-name": "scheduled_date",
                  "input-type": "datetime",
                  size: "small",
                  "field-disabled":
                    _vm.editionDisabled || _vm.task.state === "closed",
                  required: _vm.task.scheduled_date !== null,
                  min: _vm.dateNow,
                  max: _vm.activityDate
                },
                model: {
                  value: _vm.editedTask.scheduled_date,
                  callback: function($$v) {
                    _vm.$set(_vm.editedTask, "scheduled_date", $$v)
                  },
                  expression: "editedTask.scheduled_date"
                }
              }),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    label: _vm.$t("ApprovalType"),
                    "input-type": "other",
                    size: "small",
                    value: _vm.editedTask.auto_approval,
                    "variable-name": "auto_approval",
                    "field-disabled": _vm.editionDisabled
                  }
                },
                [
                  _c("treeselect", {
                    staticClass: "form-input-select",
                    attrs: {
                      value: _vm.editedTask.auto_approval,
                      options: _vm.approvalType,
                      disabled: _vm.editionDisabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateTaskApproval($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    label: _vm.$t("State"),
                    value: _vm.task.state,
                    "variable-name": "state",
                    "input-type": "other",
                    size: "small",
                    "field-disabled": true
                  }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c("activity-task-status-icon", {
                            attrs: { status: _vm.task.state }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "ml-2",
                          staticStyle: { color: "#acacae" }
                        },
                        [
                          _c("div", [
                            _vm._v(_vm._s(_vm.getStateLabel(_vm.task.state)))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: "",
                  value: "",
                  "input-type": "space",
                  size: "small"
                }
              }),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$t("Description"),
                  "variable-name": "description",
                  "input-type": "textarea",
                  size: "large",
                  "field-disabled": _vm.editionDisabled
                },
                model: {
                  value: _vm.editedTask.description,
                  callback: function($$v) {
                    _vm.$set(_vm.editedTask, "description", $$v)
                  },
                  expression: "editedTask.description"
                }
              }),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    label: _vm.$tc("Dependency", 2),
                    value: _vm.editedTask.dependencies,
                    "variable-name": "dependencies",
                    "input-type": "other",
                    size: "large",
                    "field-disabled": _vm.editionDisabled
                  }
                },
                [
                  _c("treeselect", {
                    staticClass: "form-input-select",
                    attrs: {
                      options: _vm.dependencyOptions,
                      "load-options": _vm.loadDependencyOptions,
                      normalizer: _vm.dependencyOptionsNormalizer,
                      multiple: "",
                      disabled: _vm.editionDisabled,
                      disableFuzzyMatching: ""
                    },
                    model: {
                      value: _vm.editedTask.dependencies,
                      callback: function($$v) {
                        _vm.$set(_vm.editedTask, "dependencies", $$v)
                      },
                      expression: "editedTask.dependencies"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.editedTask.type === "checklist"
                ? _c(
                    "div",
                    { staticClass: "mx-4" },
                    [
                      _c("task-checklist", {
                        attrs: {
                          task: _vm.task,
                          editionDisabled:
                            _vm.editionDisabled ||
                            _vm.editedTask.state === "completed"
                        },
                        on: {
                          addItems: _vm.addItem,
                          editItems: _vm.editItem,
                          removeItem: _vm.removeItem
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-alert",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            value: _vm.disableSave,
                            type: "error",
                            outlined: true,
                            transition: "scale-transition"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("addItemAlert")) +
                              "\n      "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editedTask.type === "photo" && _vm.editionDisabled
                ? _c(
                    "div",
                    { staticClass: "mx-4 ma-4" },
                    [
                      _c("photo-view-edit-dialog", {
                        attrs: {
                          task: _vm.editedTask.content,
                          width: _vm.width
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editedTask.type === "photo" && !_vm.editionDisabled
                ? _c(
                    "div",
                    { staticClass: "mx-4 ma-4" },
                    [
                      _c("photo", {
                        attrs: {
                          task: _vm.editedTask,
                          editionDisabled:
                            _vm.editionDisabled ||
                            _vm.editedTask.state === "completed"
                        },
                        on: {
                          removeItem: _vm.removeItem,
                          addItems: _vm.addItem,
                          editItems: _vm.editItem
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-alert",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            value: _vm.disableSave,
                            type: "error",
                            outlined: true,
                            transition: "scale-transition"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("addItemAlert")) +
                              "\n      "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editedTask.type === "mixed"
                ? _c(
                    "div",
                    { staticClass: "mx-4 ma-4" },
                    [
                      _c("Mixed", {
                        attrs: {
                          task: _vm.editedTask,
                          editionDisabled:
                            _vm.editionDisabled ||
                            _vm.editedTask.state === "completed"
                        },
                        on: {
                          addItems: _vm.addItem,
                          editItems: _vm.editItem,
                          removeItem: _vm.removeItem
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-alert",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            value: _vm.disableSave,
                            type: "error",
                            outlined: true,
                            transition: "scale-transition"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("addItemAlert")) +
                              "\n      "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editedTask.type === "text"
                ? _c(
                    "div",
                    { staticClass: "mx-auto" },
                    [
                      _c("content-text", {
                        attrs: {
                          task: _vm.editedTask,
                          editionDisabled:
                            _vm.editionDisabled ||
                            _vm.editedTask.state === "completed"
                        },
                        on: {
                          removeItem: _vm.removeItem,
                          addItems: _vm.addItem,
                          editItems: _vm.editItem
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-alert",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            value: _vm.disableSave,
                            type: "error",
                            outlined: true,
                            transition: "scale-transition"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("addItemAlert")) +
                              "\n      "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("DeleteItem"),
          content: _vm.$t("DeleteConfirmation") + " " + _vm.task.title + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.deleteDialog = false
          },
          secondaryAction: _vm.remove
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21bb2404", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21bb2404","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskDetails/TaskDetailsForm.vue
// module id = null
// module chunks = 